import { parseNoteContent } from "./modulePaymentNoteUtils";
import { formatDisplayDateTime } from "utils/dateFormat";

const TERM_SWAP_MARKER = /\[TERM_SWAP\]([\s\S]*?)\[\/TERM_SWAP\]/;

const LEGACY_TERM_SWAP =
  /\[Superadmin Term Swap\]\s+(.+?)\s+swapped Term T(\d+)\s*↔\s*Term T(\d+)\s+on (.+?)\.\s+Term labels exchanged[^.]*\.\s*Audit ref:\s*(\d+)\.\s*Warnings:\s*([^.]*)\.?/i;

export const TERM_SWAP_WARNING_LABELS = {
  paid_invoice_unchanged:
    "Paid or partially paid provider invoice — invoice lines were left unchanged; review manually.",
};

export const formatTermSwapWarnings = (warnings = []) =>
  (warnings || [])
    .filter((w) => w && w !== "none")
    .map((w) => TERM_SWAP_WARNING_LABELS[w] || String(w).replace(/_/g, " "));

const parseWarnings = (raw) => {
  const trimmed = (raw || "none").trim();
  if (!trimmed || trimmed === "none") return [];
  return trimmed
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
};

export const parseTermSwapNote = (noteText) => {
  const raw = (noteText || "").trim();
  if (!raw) return null;

  const marker = raw.match(TERM_SWAP_MARKER);
  if (marker) {
    try {
      const data = JSON.parse(marker[1]);
      return {
        actorName: data.actorName || "Super Admin",
        termA: Number(data.termA),
        termB: Number(data.termB),
        timestamp: data.timestamp || null,
        auditId: data.auditId != null ? Number(data.auditId) : null,
        warnings: Array.isArray(data.warnings) ? data.warnings : [],
      };
    } catch {
      return null;
    }
  }

  const legacy = raw.match(LEGACY_TERM_SWAP);
  if (legacy) {
    return {
      actorName: legacy[1].trim(),
      termA: Number(legacy[2]),
      termB: Number(legacy[3]),
      timestamp: legacy[4].trim(),
      auditId: Number(legacy[5]),
      warnings: parseWarnings(legacy[6]),
      legacy: true,
    };
  }

  if (!raw.startsWith("[Superadmin Term Swap]")) return null;

  const auditMatch = raw.match(/Audit ref:\s*(\d+)/i);
  const termMatch = raw.match(/Term T(\d+)\s*↔\s*Term T(\d+)/i);
  const actorMatch = raw.match(/\[Superadmin Term Swap\]\s+(.+?)\s+swapped/i);
  const warnMatch = raw.match(/Warnings:\s*([^.]+)/i);
  const dateMatch = raw.match(/on (.+?)\.\s+Term labels exchanged/i);

  if (!termMatch) return null;

  return {
    actorName: actorMatch?.[1]?.trim() || "Super Admin",
    termA: Number(termMatch[1]),
    termB: Number(termMatch[2]),
    timestamp: dateMatch?.[1]?.trim() || null,
    auditId: auditMatch ? Number(auditMatch[1]) : null,
    warnings: parseWarnings(warnMatch?.[1]),
    legacy: true,
  };
};

export const isTermSwapNote = (note) => {
  const { text } = parseNoteContent(note?.text || "");
  return Boolean(parseTermSwapNote(text));
};

export const formatTermSwapTimestamp = (timestamp) => {
  if (!timestamp) return null;
  const parsed = new Date(timestamp);
  if (!Number.isNaN(parsed.getTime())) {
    return formatDisplayDateTime(parsed);
  }
  return timestamp;
};
